import React from 'react'
import './footer.css'

import { FiFacebook } from 'react-icons/fi';
import { BsTwitter, BsInstagram  } from "react-icons/bs";

import logoGrey from '../../assets/logo-grey.svg';

const Menu = () => (
  <>
    <p><a href="#features">Products</a></p>
    <p><a href="#pricing">Pricing</a></p>
    <p><a href="#faq">FAQ</a></p>
    <p><a href="#blog">Blog</a></p>
    <p><a href="#contact">Contact</a></p>
  </>
)

const Footer = () => {
  return (
      <div className="footer">
        <div className="footer__line"></div>
        <div className="footer__container">
          <img src={logoGrey} alt="logo" className="logo__grey" />
          <div className="footer__menu">
            <Menu />
          </div>
          <div className="footer__socials">
            <FiFacebook />
            <BsTwitter />
            <BsInstagram />
          </div>
        </div>
      </div>
  )
}

export default Footer
